import logger from 'utils/logger.util';
import isNotFn from 'utils/predicates/function/isNotFn.util';

const L = logger('withFeedback');

const withFeedback = (callback, fn) => {
  if (isNotFn(callback)) {
    L.error('()', 'Not a function callback:', callback);
    return fn;
  }

  if (isNotFn(fn)) {
    L.error('()', 'Not a function fn:', fn);
    return fn;
  }

  return async (...args) => {
    try {
      callback(true);
      return await fn(...args);
    } finally {
      callback(false);
    }
  };
};

// noinspection JSUnusedGlobalSymbols
export default withFeedback;
